import axios from "@/axios"
import moment from "moment"

export default {
  data() {
    return {
      form             : this.$form.createForm(this, {name: 'coordinated'}),
      dateFormat       : 'DD-MM-YYYY',
      matter_value     : null,
      is_click_add_time: false,
      stop_time        : true,
      currency         : [],
      period_of_time   : null,
      list_practice    : [],
      loading_list     : false,
      loadingExport    : false,
      radioStyle : {display: 'block', height: '40px', lineHeight: '30px'},
      visibleRes: false,
      result: [],
      checked_matter_client: null,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      optionSearchMatter:{
        placeholder: 'Search matters',
        label: 'Matter',
        field: 'matter',
        width: '100%',
        allow_clear: true
      },
      optionSearchContact:{
        placeholder: 'Search contacts',
        label: 'Contacts',
        field: 'contact',
        width: '100%',
        allow_clear: true
      },
    }
  },

  computed:{
    expiredAccountModal() {
      const localDate = new Date(JSON.parse(localStorage.getItem('expired_account')))
      const now       = new Date();
      if(localDate) {
        const diffTime = Math.abs(localDate.getTime() - now.getTime());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      }
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    current_date(){
      return new Date().toISOString()
    },
    currentDateWithFormat(){
      return moment().format('YYYY-MM-DD')
    },
    currentDate(){
      if (this.form.getFieldValue('period_of_time'))
        return moment().format('YYYY-MM-DD')
    },
    which_bill_temp(){
      const { template_data } = this
      return TempNumber => template_data && template_data.templates && template_data.templates.template === TempNumber
    },
    hasPermission(){
      return permission => this.$hasPermission(permission)
    },
  },
  methods: {
    totalAmountTimesExpense(record) {
      const sum_expense = record.expense_entries.reduce((initial, item) => initial + item.amount,0)
      const sum_times   = record.time_entries.reduce((initial, item) => initial + (item.rate * item.duration),0)
      return Number(sum_expense + sum_times)
    },
    
    handleSelectPeriodOfTime(value){
      const val_select = value.split(',')
      this.period_of_time = moment().subtract(Number(val_select[0]), val_select[1]).format('YYYY-MM-DD')
    },
    async removeItem(index,array_item,id,new_array,item_delete,item){
      const keys = this.form.getFieldValue(item_delete);
      if(this.selectedItem && this.selectedItem.length){
        this.selectedItem = this.selectedItem.filter(itemId=> itemId !== this.form.getFieldValue(item))
      }
      if(this.editContact && id){
        this.form.setFieldsValue({
          [item_delete]: keys.filter(item => item.id !== id),
        });
        const find_id_remove = array_item.find(item=>item.id == id)
        new_array.push(find_id_remove.id)
        await axios.post(`/matter/delete/${this.$route.params.id}/`, {[item_delete]: new_array})
      }else{
        this.form.setFieldsValue({
          [item_delete]: keys.filter((item,i) => i !== index),
        });
      }
      array_item.splice(index,1)
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getRandomDigitsWords(length) {
      let result           = '';
      let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters.length;
      for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    findScrollHeight(element) {
      let height_collapse = element.scrollHeight + 240
      console.log('height_collapse 1', height_collapse, element.scrollHeight)
      this.$nextTick(() => {
        console.log('height_collapse 2', height_collapse)
        element.style.maxHeight = `${height_collapse}px`
      })
      // setTimeout(() => element.style.maxHeight = `${height_collapse}px`, 40)
    },
    findScrollHeightToValue(element, value) {
      console.log('value 1', value)
      this.$nextTick(() => {
        console.log('value 2', value)
        element.style.maxHeight = `${value}px`
      })
      // setTimeout(() => element.style.maxHeight = `${value}px`, 40)
    },
    discard(url){
      this.$router.push(url)
    },
    editMode() {
      return this.$route.params && this.$route.params.id !== undefined
    },
    checkPagenation(ref){
      ref.query.search = undefined
      ref.search_tbl = null
      const tbl_length = ref.data.length
      if(tbl_length <= 5 || tbl_length <= 10 || tbl_length <= 20) ref.query.page = 1
    },
    timer(time,form,field) {
      this.stop_time = true
      const timeString = time;
      const arr = timeString.split(":");
      const seconds = arr[0] * 3600 + arr[1] * 60 + (+arr[2]);
      const hours = (seconds / 3600).toFixed(4)
      form.setFieldsValue({[field]:hours})
    },
    clickRow(url,permission){
      if (this.hasPermission(permission)) {
        if(this.is_click_add_time){
          this.$router.push(url)
        }else{
          this.is_click_add_time = true
        }
      }
    },
    handleSearch(id){
      this.matter_value = id
    },
    convertToDecimal(field,form){
      const a = parseFloat(form.getFieldValue(field)).toFixed(2)
      if(isNaN(a)){
        return
      }
      form.setFieldsValue({[field]: a })
    },
    async getCurrency(){
      try{
        const {data} = await axios.get('/dictionary/currency/')
        this.currency = data
      }catch (e) {
        this.$message.error('Error receiving currency.')
      }
    },
    startTime(){
      this.stop_time = false
      // if(this.form.getFieldValue('recorded_time'))
      //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('recorded_time') * 3600
    },
    handleNote() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$vs.loading()
            // values.recorded_time = Number(values.recorded_time)
            if(!values.notifications) values.notifications = []
            await axios.post(`/note/`, values)
            this.open_add_note = false
            this.$notification['success']({
              message: 'Success',
              description: `Note created.`,
            });
          } catch (e) {
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
            this.open_add_note = true
            throw e
          } finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    async fetch() {
      try {
        this.loading = true;
        if(this.method === "post"){
          const {data: {rows, query}} = await axios.post(this.model.url, {...this.requestData()});
          if(rows !== undefined && query !== undefined){
            this.data            = rows
            this.query.page      = query.page
            this.query.limit     = query.limit;
            this.query.total     = query.total;
            this.query.max_page  = query.max_page;
          } else{
            this.data = data
          }
          this.$store.commit('ROWS_DATE_TBL',rows)
          this.$emit('rows',rows,this.query)
        }else{
          const {data} = await axios.get(this.model.url);
          this.data = data;
        }
      } catch (e) {
        if (e.status !== 419)
          this.$message.error('Error receiving information.');
        throw new Error(e)
      } finally {
        this.loading = false;
      }
    },
    async getPracticeArea() {
      try {
        this.loading_list  = true
        const {data}       = await axios.get('/dictionary/practice-area/')
        this.list_practice = data.filter(({owner_main})=> owner_main).reverse()
      } catch (e) {
        this.$message.error('Server error')
        throw e
      } finally {
        this.loading_list = false
      }
    },
    limitTextTask(task){
      return task && task.length > 50 ? task.substring(0,50) + '...' : task
    },
    moment(date) {
      return moment(date).fromNow()
    },
    handleRemoveSelect(e,field,form = undefined){
      if (e === undefined)
        form !== undefined ? form.resetFields(field) : this.form.resetFields(field)
    },
    handleTime({target:{value}}){
      if(value.includes(':')){
        if(value.match(/\w(?<!\d)[\w'-]*/)){
          this.form.setFieldsValue({ time_estimate : undefined })
        }else{
          const split         = value.split(':')
          const last_item     = (split[split.length - 1] / 60).toFixed(2)
          this.result_time    = +split[0] + +last_item
          value.match(/\b((\d+(\.\d+)?)\s*(h|hr|hrs?|hours?))?(\s*(\d+)\s*(m|min|mins?|minutes?))?\b/gm)
        }
      }else if(value.includes('h') && value.includes('m')){
        value      = value.split(' ').join('')
        const word = value.match(/\D+|\d+/g).filter(Number)
        if(word && word.length === 2){
          const last_item  = (word[word.length - 1] / 60).toFixed(2)
          this.result_time = +word[0] + +last_item
        }else{
          this.$message.error('Format invalid.');
        }
      }else if(value.includes('min')){
        const [num] = value.match(/\D+|\d+/g)
        this.result_time = (+num / 60).toFixed(2)
      }else if(value.includes('h')){
        const hours = value.split('h')
        this.result_time = hours[0]
      }else{
        this.form.setFieldsValue({ time_estimate : undefined })
      }
    },
    sumCol(arr,field,params) {
      if (field === 'balance' && params !== undefined)
        return arr.map(item => item.total_amount - item.payed_amount).reduce((a, b) => a + b, 0).toFixed(2)
      return arr.map(item => item[field]).reduce((a, b) => a + b, 0).toFixed(2)
    },
    groupByFilters(group) {
      if (group === 1) return 'contact'
      if (group === 2) return 'practice_area'
      if (group === 3) return 'lawyer'
    },
    dateFormatWithHour(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    handleMatterClient({target:{value}}){
      this.checked_matter_client = value
      if (value === 3) this.form.resetFields('contact')
      if (value === 2) this.form.resetFields('matter')
    },
    closeReport(){
      this.visibleRes = false;
      this.result = []
    },
    downloadPdf() {
      try{
        this.$refs.exportPdf.$refs.modalProgress.visibleProgress = true
        const content     = this.$refs.contentPdf
        if (content !==undefined) {
          const copyContent = content.cloneNode(true)
          document.getElementById('pdf').appendChild(copyContent)
        }else {
          // <h2 style="text-align: center;margin-top: 2rem">No Data</h2>
          document.getElementById('pdf').innerHTML = ""
        }
        this.$refs.exportPdf.$refs.html2Pdf.generatePdf();
      }catch (e) {
        throw e
      }
    },
    hasDownloaded(e) {
      if (e){
        document.getElementById('pdf').innerHTML = ""
        setTimeout(()=>{
          this.$refs.exportPdf.$refs.modalProgress.visibleProgress = false
        },1000)
      }
    },
    onProgress(percent) {
      this.$refs.exportPdf.$refs.modalProgress.percent = percent
    },
    async getPermissions () {
      try {
        const { data } = await axios.get('permissions/my-permission')
        const arr = [...new Set(data)]
        await this.$store.commit('PERMISSIONS',arr)
      }catch (e) {
        throw e
      }
    },
    setDateFormat(date) {
      if (date)
        return moment(date).format('DD/MM/YYYY')
    },
    validateCheckDateTo(date,field){
      if (this.form.getFieldValue(field) && date)
        return moment(date).format('YYYY-MM-DD') >= moment(this.form.getFieldValue(field)).format('YYYY-MM-DD')
      return true
    },
    validateCheckDateFrom(date,field){
      if (this.form.getFieldValue(field) && date)
        return moment(date).format('YYYY-MM-DD') <= moment(this.form.getFieldValue(field)).format('YYYY-MM-DD')
      return true
    },
    redirectPayment() {
      this.$router.push('/detail-payment').catch(()=> {})
    },
  },

  mounted() {
    this.$vs.loading.close()
  },
}
